const users = state => state.users;
const repositories = state => state.repositoryDetails;
const loadingStatus = state => state.loadingStatus;

export default {
    users,
    repositories,
    loadingStatus
}